import React, { useEffect, useState } from 'react';
import { extname } from 'path';

import styles from './VideoPlayback.module.scss';

function VideoPlayback({ videoMetadata, pageResourceId, globalState }) {
  const [forceRender, setForceRender] = useState(false);
  const [error, setError] = useState();
  const { course } = globalState;

  useEffect(() => {
    setForceRender(true);
  }, [videoMetadata]);

  useEffect(() => {
    forceRender && setForceRender(false);
  }, [forceRender]);

  return (
    <div className={styles.VideoPlayback}>
      {!forceRender && !error && (
        <video
          controls
          autoPlay
          controlsList="nodownload"
          onContextMenu={(e) => e.preventDefault()}
          onError={(err) => setError(err)}
        >
          <source
            src={`${course.baseURL}/${videoMetadata?.name}`}
            type={`video/${extname(videoMetadata?.name).replace('.', '')}`}
          />
        </video>
      )}
    </div>
  );
}

export default VideoPlayback;
